import { render } from "./SeasonNew.vue?vue&type=template&id=5905c9c6"
import script from "./SeasonNew.vue?vue&type=script&lang=js"
export * from "./SeasonNew.vue?vue&type=script&lang=js"
script.render = render

export default script